module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header'), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section is-dark is-header md-margin-top-24"
  }, [_c('div', {
    staticClass: "container margin-top"
  }, [_c('div', {
    staticClass: "col block-centered text-align-center lg-7 md-12"
  }, [_c('h1', {
    staticClass: "on-dark"
  }, [_vm._v("Tour")]), _vm._v(" "), _c('div', {
    staticClass: "padding-left padding-right margin-bottom low-text-contrast on-dark"
  }, [_vm._v("Take a tour Round the Stanel World")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container position-relative is-wide"
  }, [_c('div', {
    staticClass: "col lg-12"
  }, [_c('div', {
    staticClass: "w-layout-grid c-grid2x4"
  }, [_c('a', {
    staticClass: "link-block w-inline-block",
    attrs: {
      "id": "w-node-7f9b90f86253-9399af97",
      "data-w-id": "19ccc1ed-fe9e-99e5-db47-7f9b90f86253",
      "href": "farmmarket"
    }
  }, [_c('div', {
    staticClass: "c-gridgallery1__content-2"
  }, [_c('div', {
    staticClass: "on-dark text-medium weight-is-medium size-h2"
  }, [_vm._v("Farmer's Market")]), _vm._v(" "), _c('div', {
    staticClass: "on-dark margin-bottom-double"
  }, [_vm._v("From the tiniest to the largest products we have got all  you...")]), _vm._v(" "), _c('div', {
    staticClass: "flexh-align-center"
  }, [_c('div', {
    staticClass: "on-dark margin-right-small text-small"
  }, [_vm._v("Check Out Market")]), _vm._v(" "), _c('div', {
    staticClass: "iconfont on-dark is-11px"
  }, [_c('em', {
    staticClass: "iconfont__no-italize"
  }, [_vm._v("")])])])]), _vm._v(" "), _c('div', {
    staticClass: "c-gridgallery1__image img3"
  })]), _vm._v(" "), _c('a', {
    staticClass: "link-block w-inline-block",
    attrs: {
      "id": "w-node-7f9b90f8625e-9399af97",
      "data-w-id": "19ccc1ed-fe9e-99e5-db47-7f9b90f8625e",
      "href": "pjsupermarket"
    }
  }, [_c('div', {
    staticClass: "c-gridgallery1__content-2"
  }, [_c('div', {
    staticClass: "on-dark text-medium weight-is-medium size-h2"
  }, [_vm._v("P & J Supermarket")]), _vm._v(" "), _c('div', {
    staticClass: "on-dark margin-bottom-double"
  }, [_vm._v("From the tiniest to the largest products we have got all  you...")]), _vm._v(" "), _c('div', {
    staticClass: "flexh-align-center"
  }, [_c('div', {
    staticClass: "on-dark margin-right-small text-small"
  }, [_vm._v("View Store")]), _vm._v(" "), _c('div', {
    staticClass: "iconfont on-dark is-11px"
  }, [_c('em', {
    staticClass: "iconfont__no-italize"
  }, [_vm._v("")])])])]), _vm._v(" "), _c('div', {
    staticClass: "c-gridgallery1__image img4"
  })]), _vm._v(" "), _c('a', {
    staticClass: "link-block w-inline-block",
    attrs: {
      "id": "w-node-7f9b90f86269-9399af97",
      "data-w-id": "19ccc1ed-fe9e-99e5-db47-7f9b90f86269",
      "href": "essencespa"
    }
  }, [_c('div', {
    staticClass: "c-gridgallery1__content-2"
  }, [_c('div', {
    staticClass: "on-dark text-medium weight-is-medium size-h2"
  }, [_vm._v("Essence Spa")]), _vm._v(" "), _c('div', {
    staticClass: "on-dark margin-bottom-double"
  }, [_vm._v("From the tiniest to the largest products we have got all  you...")]), _vm._v(" "), _c('div', {
    staticClass: "flexh-align-center"
  }, [_c('div', {
    staticClass: "on-dark margin-right-small text-small"
  }, [_vm._v("Pick a Schedule ")]), _vm._v(" "), _c('div', {
    staticClass: "iconfont on-dark is-11px"
  }, [_c('em', {
    staticClass: "iconfont__no-italize"
  }, [_vm._v("")])])])]), _vm._v(" "), _c('div', {
    staticClass: "c-gridgallery1__image img6"
  })]), _vm._v(" "), _c('a', {
    staticClass: "link-block w-inline-block",
    attrs: {
      "id": "w-node-7f9b90f86274-9399af97",
      "data-w-id": "19ccc1ed-fe9e-99e5-db47-7f9b90f86274",
      "href": "chickenrepublic"
    }
  }, [_c('div', {
    staticClass: "c-gridgallery1__content-2"
  }, [_c('div', {
    staticClass: "on-dark text-medium weight-is-medium size-h2"
  }, [_vm._v("Chicken Republic")]), _vm._v(" "), _c('div', {
    staticClass: "margin-bottom-double on-dark"
  }, [_vm._v("From the tiniest to the largest products we have got all  you...")]), _vm._v(" "), _c('div', {
    staticClass: "flexh-align-center"
  }, [_c('div', {
    staticClass: "on-dark margin-right-small text-small"
  }, [_vm._v("Order now ")]), _vm._v(" "), _c('div', {
    staticClass: "iconfont on-dark is-11px"
  }, [_c('em', {
    staticClass: "iconfont__no-italize"
  }, [_vm._v("")])])])]), _vm._v(" "), _c('div', {
    staticClass: "c-gridgallery1__image img5"
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14c82643"}!./src/pages/Businesses/template.html
// module id = 234
// module chunks = 0